import { render, staticRenderFns } from "./Markenwahl.vue?vue&type=template&id=7ef54404&scoped=true&"
import script from "./Markenwahl.vue?vue&type=script&lang=js&"
export * from "./Markenwahl.vue?vue&type=script&lang=js&"
import style0 from "./Markenwahl.vue?vue&type=style&index=0&id=7ef54404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef54404",
  null
  
)

export default component.exports